import React from 'react';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    error?: string;
    helperText?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({ className = '', label, error, helperText, id, ...props }, ref) => {
        const generatedId = React.useId();
        const inputId = id || generatedId;

        return (
            <div className="w-full">
                {label && (
                    <label htmlFor={inputId} className="block text-sm font-medium text-foreground mb-2">
                        {label}
                        {props.required && <span className="text-error ml-1">*</span>}
                    </label>
                )}
                <input
                    ref={ref}
                    id={inputId}
                    className={`
            flex h-11 w-full rounded-lg border border-input bg-background px-4 py-2
            text-base ring-offset-background transition-all duration-200
            file:border-0 file:bg-transparent file:text-sm file:font-medium
            placeholder:text-muted-foreground
            focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2
            disabled:cursor-not-allowed disabled:opacity-50
            ${error ? 'border-error focus-visible:ring-error' : ''}
            ${className}
          `}
                    {...props}
                />
                {error && <p className="mt-1.5 text-sm text-error">{error}</p>}
                {helperText && !error && <p className="mt-1.5 text-sm text-muted-foreground">{helperText}</p>}
            </div>
        );
    }
);

Input.displayName = 'Input';

export default Input;
